module.exports = __webpack_public_path__ + "img/bold-nut.f4efd0f2.png";